module.exports = __webpack_public_path__ + "static/media/image-11.0b5d66b8.avif";